import { render, staticRenderFns } from "./RoleEditDetails.vue?vue&type=template&id=0a401505&"
import script from "./RoleEditDetails.vue?vue&type=script&lang=js&"
export * from "./RoleEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports